import { DocumentNode, gql, useMutation } from '@apollo/client';
import dayjs from 'dayjs';

export const ADD_JS_LOG: DocumentNode = gql`
  mutation addJsLog($input: JsLogInput) {
    addJsLog(input: $input) {
      code
      message
      content
    }
  }
`;

const normalizeJsLogValue = (value?: unknown) => {
  if (value === null || value === undefined) {
    return '';
  }

  if (typeof value === 'string') {
    return value;
  }

  try {
    return JSON.stringify(value);
  } catch (error) {
    return String(error instanceof Error ? error.message : value);
  }
};

const sanitizeJsLogText = (value?: unknown) =>
  normalizeJsLogValue(value)
    .replace(/"/g, "'")
    .replace(/\s+/g, ' ')
    .slice(0, 500);

export const useAddJsLog = () => {

  const [rawReqAddJsLog] = useMutation(ADD_JS_LOG);

  const reqAddJsLog = ({ variables, ...rest }: any) => {
    const input = variables?.input || {};

    return rawReqAddJsLog({
      ...rest,
      variables: {
        ...variables,
        input: {
          ...input,
          time:
            typeof input.time === 'string' && input.time.trim()
              ? input.time
              : dayjs().format('YYYY-MM-DD HH:mm:ss'),
          remark1: sanitizeJsLogText(input.remark1),
          remark2: sanitizeJsLogText(input.remark2),
          remark3: sanitizeJsLogText(input.remark3),
          remark4: sanitizeJsLogText(input.remark4),
          remark5: sanitizeJsLogText(input.remark5),
        },
      },
    });
  };

  return {
    reqAddJsLog
  }
}
